import { render, staticRenderFns } from "./SectionGlobalStandard.vue?vue&type=template&id=db05d276&scoped=true"
import script from "./SectionGlobalStandard.vue?vue&type=script&lang=ts"
export * from "./SectionGlobalStandard.vue?vue&type=script&lang=ts"
import style0 from "./SectionGlobalStandard.vue?vue&type=style&index=0&id=db05d276&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "db05d276",
  null
  
)

export default component.exports